import React from 'react';
import syringeIcon from '../../../assets/icons/syringe-icon.png';

const SyringeIcon = ({ size = 24, ...props }) => (
    <img
        src={syringeIcon}
        alt='Syringe Icon'
        width={size}
        height={size}
        style={{
            objectFit: 'contain',
            filter: 'brightness(0) saturate(100%) invert(70%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0.9) contrast(1)',
        }}
        {...props}
    />
);

export default SyringeIcon;
